import "../../styles/style"
import "../../sticky/style"
import "../../swiper/style"
import "../index.scss"
